export interface BatchStatisticsGetSelectItemRequest {
  batchType: string
}

export function BatchStatisticsGetSelectItemRequestToJSON(
  value: BatchStatisticsGetSelectItemRequest
): any {
  return {
    batch_type: value.batchType
  }
}
